import { schema } from 'normalizr';

import request from 'utils/request';

export const processSchema = new schema.Entity('processes');

export default {
  list: async (groupId) => await request(`/suppliers/${groupId}/processes`),

  create: async (groupId, data) =>
    await request.post(`/suppliers/${groupId}/processes`, data),

  downloadAccountYaml: async (groupId, data) => {
    const response = await request.post(
      `/suppliers/${groupId}/account_config_download`,
      data,
    );
    return response;
  },

  uploadAccountYaml: async (groupId, data) => {
    const response = await request.post(
      `/suppliers/${groupId}/account_config_upload`,
      data,
    );
    return response;
  },

  validateAccountYaml: async (groupId, data) => {
    const response = await request.post(
      `/suppliers/${groupId}/account_config_validation`,
      data,
    );
    return response;
  },
};
